<div class="h-100 d-flex justify-content-around align-items-center gap-0_5">
    <i class="cp icon-tests-settings" (click)="onClick('copy')" tooltip="Test case details"></i>
    <i class="cp icon-more" (click)="onClick('more')" tooltip="More actions"></i>
</div>
